export const CREATE_SUCCESS_MSG = 'created successfully';
export const UPDATE_SUCCESS_MSG = 'updated successfully';
export const DELETE_SUCCESS_MSG = 'deleted successfully';
export const VOID_SUCCESS_MSG = 'voided successfully';

export const LOAD_SUCCESS_MSG = 'loaded successfully';
export const LOAD_FAIL_MSG = 'Failed to load';

export const REQUIRED_FIELDS_MSG = 'Please validate & fill in all required fields';
